import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  private menuToggle: HTMLInputElement | null = null;

  constructor() { }

  setMenuToggle(menuToggle: HTMLInputElement): void {
    this.menuToggle = menuToggle;
  }

  closeMenu(): void {
    if (this.menuToggle) {
      this.menuToggle.checked = false;
    }
  }

}
